import React, { useState, useEffect } from "react";
import "./../StockCard.css"; // Importing the CSS file
import upIcon from '../assets/up_icon.png';
import downIcon from '../assets/down_icon.png';

const ScoreCard = ({ stock, _stock, onCardClick, isDarkMode = false, proView = false, openPosition = null }) => {
  const { Symbol, Ask, Bid, LTP, High, Low, Open, Prev_Close, ExpiryDate } = stock;
  const [prevBid, setPrevBid] = useState(_stock.Bid);
  const [prevAsk, setPrevAsk] = useState(_stock.Ask);
  const [prevLtp, setPrevLtp] = useState(_stock.LTP != undefined ? _stock.LTP : stock.lastTradedPrice);


  // Calculate the change percentage
  const _Bid = _stock.Bid!=undefined ? _stock.Bid : stock.buyPrice;
  const _Ask = _stock.Ask!=undefined ? _stock.Ask : stock.sellPrice;
  const _Open = _stock.Open!=undefined ? _stock.Open : stock.open;
  const _High = _stock.High!=undefined ? _stock.High : stock.high;
  const _Low = _stock.Low!=undefined ? _stock.Low : stock.low;
  const _Prev_Close = _stock.Prev_Close!=undefined ? _stock.Prev_Close : stock.close;
  const _LTP = _stock.LTP!=undefined ? _stock.LTP : stock.lastTradedPrice;

  const Change_per = ((_LTP - _Prev_Close) / _Prev_Close * 100).toFixed(2);
  const Change = (_LTP - _Prev_Close).toFixed(2);
  const changeColor = Change > 0 ? "green" : "red";

  const handleClick = () => {
    stock['live'] = _stock;
    onCardClick(stock);
  };

  const [bidChangeClass, setBidClass] = useState('green');
  const [askChangeClass, setAskClass] = useState('red');
  const [ltpChangeClass, setLtpClass] = useState('');

  // Compare Bid and Ask with previous values
  // const bidChangeClass = _Bid > prevBid ? 'green' : _Bid < prevBid ? 'red' : '';
  // const askChangeClass = _Ask > prevAsk ? 'green' : _Ask < prevAsk ? 'red' : '';

  // Update the previous values on every render
  useEffect(() => {
    if (_Bid !== prevBid) {
      //console.log(`Bid changed: Old Bid = ${prevBid}, New Bid = ${_Bid}`);
     let a = _Bid > prevBid ? setBidClass('green') : _Bid < prevBid ? setBidClass('red') : '';
    }
    if (_Ask !== prevAsk) {
      //console.log(`Ask changed: Old Ask = ${prevAsk}, New Ask = ${_Ask}`);
      let b = _Ask > prevAsk ? setAskClass('green') : _Ask < prevAsk ? setAskClass('red') : '';
    }
    if (_LTP !== prevLtp) {
      _LTP > prevLtp ? setLtpClass('green') : _LTP < prevLtp ? setLtpClass('red') : setLtpClass('');
    }
    setPrevBid(_Bid);
    setPrevAsk(_Ask);
    setPrevLtp(_LTP);
    
  }, [_Bid, _Ask, _LTP, prevBid, prevAsk, prevLtp]);

  const formatPositionQty = (qty) => {
    const value = Number(qty || 0);
    if (!value) {
      return '0';
    }
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
  };

  const positionSideClass = openPosition?.side === 'Buy' ? 'position-buy' : 'position-sell';

  return (
    <div className={`quote-row ${isDarkMode ? 'dark-theme' : 'light-theme'}`} onClick={handleClick}>
      {proView ? (
        // Pro View - Current detailed view
        <div className="main-content">
          {/* Script Column */}
          <div className="script-column">
            <div className="script-info">
              <div className="change-indicator">
                {Change > 0 ? (
                  <span className="change-arrow up">▲</span>
                ) : (
                  <span className="change-arrow down">▼</span>
                )}
                <span className={`change-value ${changeColor}`}>
                  {Math.abs(Change).toFixed(2)} ({Math.abs(Change_per)}%)
                </span>
              </div>
              <div className={`script-name ${stock.exchange === 'OPTSTK' ? 'optstk-font' : 'normal-font'}`}>
                {stock.dispname}
                {String(stock.lotVariant || '').toUpperCase() === 'MINI' && <span className="lot-variant-mini">MINI</span>} 
              </div>
              <div className="script-expiry">
                {stock.expiry}
              </div>
              
              <div className="ohlc-info">
                <span className="ohlc-label">LTP:</span>
                <span className={`ohlc-value ${ltpChangeClass}`}>{Number(_LTP).toFixed(2)}</span>
              </div>
            </div>
          </div>

          {/* Bid Column */}
          <div className="bid-column">
            <div className="price-container">
              {/* <div className={`current-price ${_Bid > prevBid ? 'price-up' : _Bid < prevBid ? 'price-down' : 'price-neutral'}`}> */}
              <div className={`stock-price ${bidChangeClass}`}>
                {Number(_Bid).toFixed(2)}
              </div>
              <div className="hl-info">
                <span className="hl-label">High:</span>
                <span className="hl-value">{Number(_High).toFixed(2)}</span>
              </div>
              <div className="ohlc-info">
                <span className="ohlc-label">Open:</span>
                <span className="ohlc-value">{Number(_Open).toFixed(2)}</span>
              </div>
            </div>
          </div>

          {/* Ask Column */}
          <div className="ask-column">
            <div className="price-container">
              {openPosition && (
                <div className={`open-position-qty ${positionSideClass}`}>
                  {openPosition.side} Qty: {formatPositionQty(openPosition.qty)}
                </div>
              )}
              {/* <div className={`current-price ${_Ask > prevAsk ? 'price-up' : _Ask < prevAsk ? 'price-down' : 'price-neutral'}`}> */}
              <div className={`stock-price ${askChangeClass}`} style={{marginTop: openPosition ? '-2px' : '15px'}}>
                {Number(_Ask).toFixed(2)}
              </div>
              <div className="hl-info">
                <span className="hl-label">Low:</span>
                <span className="hl-value">{Number(_Low).toFixed(2)}</span>
              </div>
              <div className="ohlc-info">
                <span className="ohlc-label">Close:</span>
                <span className="ohlc-value">{Number(_Prev_Close).toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Simple View - Price change, script name, bid/ask
        <div className="simple-content">
          {/* Script Name and Price Change */}
          <div className="simple-script-info">
            <div className="script-name">
              {stock.dispname}
              {String(stock.lotVariant || '').toUpperCase() === 'MINI' && <span className="lot-variant-mini">MINI</span>}
            </div>
            <div className="script-expiry">
              {stock.expiry}
            </div>
            {openPosition && (
              <div className={`open-position-qty ${positionSideClass}`}>
                {openPosition.side} Qty: {formatPositionQty(openPosition.qty)}
              </div>
            )}
            <div className="change-indicator">
              {Change > 0 ? (
                <span className="change-arrow up">▲</span>
              ) : (
                <span className="change-arrow down">▼</span>
              )}
              <span className={`change-value ${changeColor}`}>
                {Math.abs(Change).toFixed(2)} ({Math.abs(Change_per)}%)
              </span>
            </div>
          </div>

          {/* Bid and Ask */}
          <div className="simple-price-info">
            <div className="bid-ask-container">
              <div className="bid-section">
                <div className="price-label">Bid</div>
                {/* <div className={`current-price ${_Bid > prevBid ? 'price-up' : _Bid < prevBid ? 'price-down' : 'price-neutral'}`}> */}
                <div className={`stock-price-simple-view ${bidChangeClass}`}>
                  {Number(_Bid).toFixed(2)}
                </div>
              </div>
              <div className="ask-section">
                <div className="price-label">Ask</div>
                {/* <div className={`current-price ${_Ask > prevAsk ? 'price-up' : _Ask < prevAsk ? 'price-down' : 'price-neutral'}`}> */}
                <div className={`stock-price-simple-view ${askChangeClass}`}>
                  {Number(_Ask).toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoreCard;
